(() => {
  const notice = document.getElementById('katy-second-product-notice');
  if (!notice) return;
  const prefix = 'katy-second-product-v4:';
  const memory = {};
  const read = key => { try { return sessionStorage.getItem(prefix + key); } catch { return memory[key]; } };
  const write = (key, value) => { memory[key] = value; try { sessionStorage.setItem(prefix + key, value); } catch {} };
  let timer;
  const show = stage => {
    if (read('dismissed') || (stage !== 'product-intro' && read(stage))) return;
    notice.hidden = false;
    write(stage, '1');
  };
  notice.querySelector('button').addEventListener('click', () => {
    notice.hidden = true;
    clearTimeout(timer);
    write('dismissed', '1');
  });
  const pending = read('pending-add');
  if (notice.dataset.page === 'cart' && pending) {
    const baseline = Number(pending);
    const count = Number(notice.dataset.cartCount);
    write('pending-add', '');
    if (count > baseline) timer = setTimeout(() => show('cart-reminder'), 700);
  } else if (notice.dataset.page === 'product') {
    timer = setTimeout(() => show('product-intro'), 700);
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.href);
    if (/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) {
      write('pending-add', notice.dataset.cartCount);
    }
  }, true);
  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).ajaxSuccess((event, xhr, settings) => {
      if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(settings.url || '')) {
        clearTimeout(timer);
        show('cart-reminder');
      }
    });
  }
})();